<template>
    <div id="account_setting_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="glAccountHeader">Account Setting</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content account-setting">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="glAccountForm">
                                <h6 class="color-darkblue font-semibold">Default Chart of account</h6>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="gl_account">Account Receivable:</label>
                                        <v-select v-model="ar_gl_account_id" name="gl_account_id" id="ar_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search GL Account...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ar_gl_account_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="gl_account">Account Payable:</label>
                                        <v-select v-model="ap_gl_account_id" name="gl_account_id" id="ap_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search GL Account...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ap_gl_account_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="gl_account">Sales:</label>
                                        <v-select v-model="sales_gl_account_id" name="gl_account_id" id="sales_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search GL Account...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{sales_gl_account_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="gl_account">General Expenses:</label>
                                        <v-select v-model="ge_gl_account_id" name="gl_account_id" id="ge_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search GL Account...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ge_gl_account_error_msg}}</div>
                                    </div>
                                </div>
                            </form>
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="AccountTypeForm">
                                <h6 class="color-darkblue font-semibold mt-4">Default Types</h6>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="account_type">Bank & Cash:</label>
                                        <v-select v-model="account_type" name="account_type" placeholder="Select Account Type."
                                                label="text"
                                                :options="accountTypesArr" id="account_type">
                                        </v-select>
                                        <div class="field-error">{{account_type_error_msg}}</div>                                                
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="account_type">Tax:</label>
                                        <v-select v-model="tax_account_type" name="account_type" placeholder="Select Account Type."
                                                label="text"
                                                :options="accountTypesArr" id="tax_account_type">
                                        </v-select>
                                        <div class="field-error">{{tax_account_type_error_msg}}</div>                                                
                                    </div>
                                </div>
                            </form>
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="AccountForm">
                                <div class="btn-groups">
                                    <button type="submit" id="CreateAccountBtn" class="btn btn-primary" v-on:click.prevent="CreateAccountSetting" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
  name: "AccountSettingCreate",
  metaInfo() {
    return {
        title: "Create Account Setting | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    account_type:"",
    accountTypesArr:[],
    loading:false,
    account_type_error_msg:"",
    tax_account_type:'',
    tax_account_type_error_msg:'',  
    ap_gl_account_id:'',
    ar_gl_account_id:'',
    sales_gl_account_id:'',
    ge_gl_account_id:'',
    accountsArr:[],
    ar_gl_account_error_msg:'',
    ap_gl_account_error_msg:'',
    sales_gl_account_error_msg:'',
    ge_gl_account_error_msg:''
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'default_account_setting') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['accountTypes']);
        self.loadAccountSetting();
  },
  methods: {
    BackGLAccountsList() {
      var self = this;
      self.$router.push("/gl-account/list");
    },

     onSearchAccount(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'accounts', '');
        }
    },

    CreateAccountSetting() {
      var self = this;
      var error = false;      
      self.ge_gl_account_error_msg = "";
      self.ar_gl_account_error_msg = "";
      self.ap_gl_account_error_msg = "";
      self.sales_gl_account_error_msg = "";
      self.account_type_error_msg = "";
      self.tax_account_type_error_msg = "";

      if (self.ar_gl_account_id == null || !self.ar_gl_account_id.value) {
        self.ar_gl_account_error_msg = "Account Receivable Account Required.";
        error = true;
      }
      if (self.ap_gl_account_id == null || !self.ap_gl_account_id.value) {
        self.ap_gl_account_error_msg = "Account Payable Account Required.";
        error = true;
      }
      if (self.sales_gl_account_id == null || !self.sales_gl_account_id.value) {
        self.sales_gl_account_error_msg = "Sales Account Required.";
        error = true;
      }
      if (self.ge_gl_account_id == null || !self.ge_gl_account_id.value) {
        self.ge_gl_account_error_msg = "General Expenses Account Required.";
        error = true;
      }

      if (!self.account_type || self.account_type == null || !self.account_type.value) {
        self.account_type_error_msg = "Account Type Required.";
        error = true;
      }

      if (!self.tax_account_type || self.tax_account_type == null || !self.tax_account_type.value) {
        self.tax_account_type_error_msg = "Tax Account Type Required.";
        error = true;
      }
      
      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateAccountBtn").val("Updating ...");
                $("#CreateAccountBtn").prop("disabled", true);
                $("#cancelAccountBtn").prop("disabled",true);
            } else {
                $("#CreateAccountBtn").val("Saving ...");
                $("#CreateAccountBtn").prop("disabled", true);
                $("#createAndContinueGLAccountBtn").prop("disabled", true);
                $("#cancelAccountBtn").prop("disabled",true);
            }
            
            var fields = [];

            // var arr = [];

            // arr.push({
            //     account_receivable:self.ar_gl_account_id.value,
            //     filterValue: contentArr.filterValue,
            //     columnId: contentArr.columnId,
            //     isColumnDisable:contentArr.isColumnDisable,
            //     filterTypeArr:contentArr.filterTypeArr,
            // });
           
           fields.push({name: "account_receivable", value: self.ar_gl_account_id.value});
           fields.push({name: "account_payable", value: self.ap_gl_account_id.value});
           fields.push({name: "sales_account", value: self.sales_gl_account_id.value});
           fields.push({name: "general_expense_account", value: self.ge_gl_account_id.value});
            fields.push({name: "bank_cash_account_type", value: self.account_type.value});
            fields.push({name: "tax_account_type", value: self.tax_account_type.value});
            if (segments[3]){
                
                fields.push({name: "id", value: segments[3]});

            }

            $.ajax({
                url: process.env.ROOT_API + "/account-setting/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                   
                    $("#CreateAccountBtn").val("Saving ...");
                    $("#CreateAccountBtn").prop("disabled", false);
                    $("#cancelAccountBtn").prop("disabled",false);

                    if (data.status == "success") {

                        self.loadAccountSetting();

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            setTimeout(function () {
                                self.common_error_msg = "";
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;

                    $("#CreateAccountBtn").val("Save");
                    $("#CreateAccountBtn").prop("disabled", false);
                    $("#cancelAccountBtn").prop("disabled",false);

                    self.generateStatusCodeMessage(jqXHR,false,'account-setting-create');
                }
            });
      }else{
          self.errorValidationFocus();
      }
    },

    loadAccountSetting() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/account-setting/load",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {

                    if (data.content.account_receivable){
                        self.ar_gl_account_id = data.content.account_receivable;
                    }
                    if (data.content.account_payable){
                        self.ap_gl_account_id = data.content.account_payable;
                    }
                    if (data.content.sales_account){
                        self.sales_gl_account_id = data.content.sales_account;
                    }
                    if (data.content.general_expense_account){
                        self.ge_gl_account_id = data.content.general_expense_account;
                    }
                    if (data.content.bank_cash_account_type){
                        self.account_type = data.content.bank_cash_account_type;
                    }
                    if (data.content.tax_account_type){
                        self.tax_account_type = data.content.tax_account_type;
                    }
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'glaccount-details');
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/accounting/AccountSetting.vue